export default __webpack_public_path__ + "static/search-49276f014418fb6ba96295c13dd6a5f2.png";